// extracted by mini-css-extract-plugin
export var heading = "style-module--heading--841cd";